<div class="modal-box strategy-review-form-modal" cdkDrag>
    <form class="strategy-review-form-modal__form" [formGroup]="addTaskForm" (ngSubmit)="onSubmit()">
        <input type="hidden" formControlName="campaignId">
        <input type="hidden" formControlName="clientId">
        <input type="hidden" formControlName="dueDate">
        <input type="hidden" formControlName="assignedUserId">
        <input type="hidden" formControlName="title">
        <div class="modal-header strategy-review-form-modal__header" cdkDragHandle>
            <div class="strategy-review-form-modal__headline">
                <span class="strategy-review-form-modal__eyebrow">{{ 'FORMS' | translate }}</span>
                <h4 class="modal-title strategy-review-form-modal__title">{{ 'STRATEGY_REQUEST_FORM' | translate }}</h4>
            </div>
            <button type="button" class="strategy-review-form-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body strategy-review-form-modal__body">
            <section class="strategy-review-form-modal__panel">
                <p class="strategy-review-form-modal__intro">{{ 'STRATEGY_REQUEST_FORM_INTRO' | translate }}</p>
                <div class="strategy-review-form-modal__field">
                    <label class="strategy-review-form-modal__label" for="description">{{ 'ADDITIONAL_DETAILS_OPTIONAL' | translate }}</label>
                    <textarea id="description" class="form-control strategy-review-form-modal__control strategy-review-form-modal__control--textarea" rows="3" formControlName="description"
                        [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                        [placeholder]="'STRATEGY_REQUEST_FORM_PLACEHOLDER' | translate"></textarea>
                    <div *ngIf="submitted && f.description.errors" class="strategy-review-form-modal__feedback">
                        <div *ngIf="f.description.errors.required">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal-footer strategy-review-form-modal__footer" cdkDragHandle>
            <div class="strategy-review-form-modal__actions">
                <button class="red-outline-button strategy-review-form-modal__button" type="button" (click)="close()">{{ 'CANCEL' | translate }}</button>
                <button class="blue-button strategy-review-form-modal__button" id="submit-change-tech" type="submit" [disabled]="addTaskForm.invalid || addTaskForm.disabled">{{ 'SUBMIT' | translate }}</button>
            </div>
        </div>
    </form>
</div>
